function HcUpdateCrossedOut(opts) { 
  const {
    variants,
    options,
    optionNames,
    selectors,
  } = opts;
  
  const {
    radioAllElements: radioAllSelector, // A selector to match all the radio buttons
    radioElement: radioSelector, // the input element with the swatch (index: number): string
    radioContainer: swatchSelector // the parent of the radio button to update 
  } = selectors; 

  // Get option index by name 
  const getIndex = optionName => options.findIndex(op => op.toLowerCase() == optionName.toLowerCase())  

  // Get available option for $x in ["red", "$x", "long"] 
  function getAvailableOptions(options) {
    const req_index = options.findIndex(opt => opt == "$x");
    if (req_index < 0) throw new TypeError("$x must be passed to the options array");

    return variants
    .filter(variant => {
      for (const [index, opt] of variant.options.entries()) {
        if (!variant.available || (options[index] !== opt && index !== req_index)) return false;
      }
      return true;
    })
    .map(variant => variant.options[req_index]);
  }
  
  // Get an array of the selected options similar to variant.options 
  const getSelectedOptions = () => options.map((name, index) => document.querySelector(radioSelector(index) + ':checked').value);
  
  
  function updateOptions(selectedOptions) {
        
    const optionSelectors = optionNames.map(optionName => {
      const optIndex = getIndex(optionName)
      return [optIndex, radioSelector(optIndex)];
    }); 
    
    for (const [reuquestedOptionIndex, optionSelector] of optionSelectors) {
      const availableValues = getAvailableOptions(selectedOptions.map((val, index) => index === reuquestedOptionIndex ? "$x" : val));
      const radios = document.querySelectorAll(optionSelector);
      radios.forEach(el => el.closest(swatchSelector).classList.toggle('hc-soldout-option', !availableValues.includes(el.value)));
    }
  }
  
  function onLoad() {
    document.body.addEventListener('change', e => {
      if (e.target.closest(radioAllSelector)) {
        let selectedOptions;
        if (!selectedOptions) selectedOptions = getSelectedOptions();
        updateOptions(selectedOptions);
      }
    });
  }
  
  window.addEventListener('DOMContentLoaded', onLoad);
}